import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { reciepentColumn } from "../metadata/reciepent";
import "./page.css"
import { useActionsHook } from "../hooks/useActionsHook";



import { useNavigate } from "react-router";
import { useGetAllRecieverByCodeQuery } from "../store/api/directory/recieverApi";

function Recievers() {
	const [selectedProducts, setSelectedProducts] = useState(null);
	const navigate = useNavigate();
	const { data, error, isLoading } = useGetAllRecieverByCodeQuery();
	const handlePrint = (e, data) => {
		setTimeout(() => {
			const win = window.open("", "", "height=300,width=600");
			win.document.write("<html><head><title>Print</title></head><body>");
			win.document.write(`<p>${data.client_code}</p>`);
			win.document.write("</body></html>");
			win.document.close();
			win.focus();
			win.print();
			win.close();
		}, 100);
	};
	const actions = useActionsHook([
		{
			onClick: handlePrint,
			icon: "pi pi-print"
		}
	])
	function toggleSidebar(bool, data) {
	}


	return (<>
		<PresortDemo
			selection={selectedProducts}
			selectionMode="multiple"
			onSelectionChange={(e) => setSelectedProducts(e.value)}
			isLoading={isLoading}
			data={data}
			paginator={true}
			scrollHeight="calc(100vh - 120px)"
			column={reciepentColumn ?? Object.keys(data.data[0])}
			toggleSidebar={toggleSidebar}
			actions={actions} />
	</>);
}
export default Recievers;